import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {EnumValidValueModel} from '../../../models/enum/enum-valid-value.model';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';

@Injectable({
  providedIn: 'root'
})
export class ValidValuesService {
  constructor(private http: HttpClient) { }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any) => {
      console.error(error);
      return of(result as T);
    };
  }

  getGetenumValidValue(guid: string): Observable<any> {
    return this.http.get<any>(`/api/ValidValues/${guid}`)
      .pipe(catchError(this.handleError<any>('getGetenumValidValue')));
  }

  getGetenumValidValues(): Observable<EnumValidValueModel[]> {
    return this.http.get<any>(`/api/valid-value/get-all-valid-values`)
      .pipe(catchError(this.handleError<EnumValidValueModel[]>('GetenumValidValues4Conf')));
  }

  callUpdateenumValidValue(guid: string): Observable<any> {
    return this.http.post<any>(`/api/validvalues/${guid}`, {})
      .pipe(catchError(this.handleError<any>('callUpdateenumValidValue')));
  }

  callPutenumValidValue(validValues: any): Observable<void> {
    console.log('callPutenumValidValue');
    console.log(validValues);
    return this.http.put<void>(`/api/validvalues/putEnumValidValueItems`, validValues)
      .pipe(catchError(this.handleError<any>('callUpdateenumValidValue')));
  }

  callUpdateEnumValidValueName(validValues: any): Observable<void> {
    console.log('callUpdateEnumValidValueName');
    console.log(validValues);
    return this.http.put<void>(`/api/validvalues/UpdateEnumValidValueName`, validValues)
      .pipe(catchError(this.handleError<any>('callUpdateEnumValidValueName')));
  }

  saveValidValueItem(validValueItem: EnumValidValueItemModel): Observable<EnumValidValueItemModel> {
    // console.log('guid 456 ', guid);
    return this.http.post<EnumValidValueItemModel>(`/api/valid-value/save-valid-value-item`, validValueItem)
      .pipe(catchError(this.handleError<any>('saveValidValueItem')));
  }

  deleteValidValueItem(validValueItem: EnumValidValueItemModel): Observable<EnumValidValueItemModel> {
    return this.http.post<EnumValidValueItemModel>(`/api/valid-value/delete-valid-value-item`, validValueItem)
      .pipe(catchError(this.handleError<any>('deleteValidValueItem')));
  }

  saveValidValue(validValue: EnumValidValueModel): Observable<EnumValidValueModel> {
    return this.http.post<EnumValidValueModel>(`/api/valid-value/save-valid-value`, validValue)
      .pipe(catchError(this.handleError<any>('saveValidValue')));
  }

  deleteValidValue(validValue: EnumValidValueModel): Observable<EnumValidValueModel> {
    return this.http.post<EnumValidValueModel>(`/api/valid-value/delete-valid-value`, validValue)
      .pipe(catchError(this.handleError<any>('deleteValidValue')));
  }

  callInsertenumValidValueItem(validValueItem: EnumValidValueItemModel): Observable<any> {
    return this.http.post<any>(`/api/ValidValues/AddValidValueItems`, validValueItem)
      .pipe(catchError(this.handleError<any>('callInsertenumValidValueItem')));  }

  callGetenumValidValueItems(Name: string): Observable<any[]> {
    return this.http.get<any>(`api/valid-values/${Name}`)
      .pipe(catchError(this.handleError<any>('callGetenumValidValueItems')));
  }
}
